import React, { memo } from 'react'

import { DisplayingEditor } from 'common/components'
import { useAppDispatch, useAppSelector } from 'common/hooks'
import { Task } from 'data/categories'
import { setTaskLines, selectResultsByLines } from 'features/simulator'

type PropsType = {
  task: Task
  scrollTop: number
}

export const TaskDisplay = memo(({ task, scrollTop }: PropsType) => {
  const dispatch = useAppDispatch()

  const resultsByLines = useAppSelector(selectResultsByLines)

  const createEditorHandler = (lines: string[]) => {
    dispatch(setTaskLines(lines))
  }

  // it's called when switching tasks
  const onChange = (lines: string[]) => {
    dispatch(setTaskLines(lines))
  }

  return (
    <div className="box box--editor">
      <DisplayingEditor
        value={task.code}
        language={task.lang}
        scrollTop={scrollTop}
        resultsByLines={resultsByLines}
        onCreateEditor={createEditorHandler}
        onChange={onChange}
      />
    </div>
  )
})
